module.exports = __webpack_public_path__ + "static/img/Arnergy-5000.5f3b926.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Arnergy-5000.jpeg
// module id = 3003
// module chunks = 1